<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img class="c-avatar-img" src="https://www.gravatar.com/avatar/64e1b8d34f425d19e1ee2ea7236d3028.jpg?s=80&amp;d=mm&amp;r=g">
        </div>
        <span class="d-md-down-none" style="padding-left:3px">{{ currentUserName }}</span>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Settings</strong>
    </CDropdownHeader>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  computed: {
    currentUserName: function () {
      return localStorage.getItem('user_name')
    }
  },
  data () {
    return { 
      itemsCount: 42
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('access_token')
      localStorage.removeItem('user_name')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>